//#region ../../node_modules/lodash-es/_asciiToArray.js
/**
* Converts an ASCII `string` to an array.
*
* @private
* @param {string} string The string to convert.
* @returns {Array} Returns the converted array.
*/
function asciiToArray(string) {
	return string.split("");
}
var _asciiToArray_default = asciiToArray;

//#endregion
export { _asciiToArray_default as default };
//# sourceMappingURL=_asciiToArray.js.map